import { getImagesByQuery } from "./js/pixabay-api.js";
import { createGallery, clearGallery, showLoader, hideLoader } from "./js/render-functions.js";
import iziToast from "izitoast";
import 'izitoast/dist/css/iziToast.min.css';
const form = document.querySelector(".form");
const input = form.elements["search-text"];

form.addEventListener("submit", (e) => {
    e.preventDefault();
    const query = input.value.trim();
    if (!query) {
        iziToast.error({
            title: 'Error',
            message: 'Please enter a search term.',
        });
        return;
    }
    clearGallery();
    showLoader();
    
    getImagesByQuery(query)
        .then((data) => {
            if (data.hits.length === 0) {
                iziToast.error({
                    title: 'No result',
                    message:
                        'Sorry, there are no images matching your search query. Please try again!',
                });
                return;
            }
            createGallery(data.hits);
        })
        .catch((error) => {
            iziToast.error({
                title: 'Error',
                message: 'Something went wrong. Please try again.',
            });
            console.error(error);
        })
        .finally(() => {
            hideLoader();
        });

});